var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeMutable = makeMutable;
exports.makeRemote = makeRemote;
exports.makeUIMutable = void 0;
var _NativeReanimated = _interopRequireDefault(require("./NativeReanimated"));
var _shareables = require("./shareables");
var _threads = require("./threads");
var _valueSetter = require("./valueSetter");
var _worklet_6202761388909_init_data = {
    code: "function makeUIMutable(initial,syncDataHolder){const{valueSetter,makeShareableCloneOnUIRecursive}=this.__closure;const listeners=new Map();let value=initial;const self={set value(newValue){valueSetter(self,newValue);},get value(){return value;},set _value(newValue){value=newValue;if(syncDataHolder){_updateDataSynchronously(syncDataHolder,makeShareableCloneOnUIRecursive(newValue));}listeners.forEach(function(listener){listener(newValue);});},get _value(){return value;},addListener:function(id,listener){listeners.set(id,listener);},removeListener:function(id){listeners.delete(id);},_animation:null,_isReanimatedSharedValue:true};return self;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/mutables.ts",
    sourceMap: '{"version":3,"names":["makeUIMutable","initial","syncDataHolder","valueSetter","makeShareableCloneOnUIRecursive","__closure","listeners","Map","value","self","newValue","_value","_updateDataSynchronously","forEach","listener","addListener","id","set","removeListener","delete","_animation","_isReanimatedSharedValue"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/mutables.ts"],"mappings":"AAUO,SAAAA,aAASA,CAAcC,OAC5B,CAAUC,cACV,CAA8C,OAAAC,WAAA,CAAAC,+BAAA,OAAAC,SAAA,CAI9C,KAAM,CAAAC,SAAS,CAAG,GAAI,CAAAC,GAAG,CAAC,CAAC,CAC3B,GAAI,CAAAC,KAAK,CAAGP,OAAO,CAEnB,KAAM,CAAAQ,IAAI,CAAG,CACX,GAAI,CAAAD,KAAKA,CAACE,QAAQ,CAAE,CAClBP,WAAW,CAACM,IAAI,CAAEC,QAAQ,CAAC,CAC7B,CAAC,CACD,GAAI,CAAAF,KAAKA,CAAA,CAAG,CACV,MAAO,CAAAA,KAAK,CACd,CAAC,CAOD,GAAI,CAAAG,MAAMA,CAACD,QAAW,CAAE,CACtBF,KAAK,CAAGE,QAAQ,CAChB,GAAIR,cAAc,CAAE,CAClBU,wBAAwB,CACtBV,cAAc,CACdE,+BAA+B,CAACM,QAAQ,CAC1C,CAAC,CACH,CACAJ,SAAS,CAACO,OAAO,CAAE,SAAAC,QAAQ,CAAK,CAC9BA,QAAQ,CAACJ,QAAQ,CAAC,CACpB,CAAC,CAAC,CACJ,CAAC,CACD,GAAI,CAAAC,MAAMA,CAAA,CAAM,CACd,MAAO,CAAAH,KAAK,CACd,CAAC,CACDO,WAAW,CAAE,QAAAA,CAACC,EAAU,CAAEF,QAA+B,CAAK,CAC5DR,SAAS,CAACW,GAAG,CAACD,EAAE,CAAEF,QAAQ,CAAC,CAC7B,CAAC,CACDI,cAAc,CAAE,QAAAA,CAACF,EAAU,CAAK,CAC9BV,SAAS,CAACa,MAAM,CAACH,EAAE,CAAC,CACtB,CAAC,CACDI,UAAU,CAAE,IAAI,CAChBC,wBAAwB,CAAE,IAC5B,CAAC,CACD,MAAO,CAAAZ,IAAI,CACb"}',
    version: "3.5.4"
};
var makeUIMutable = exports.makeUIMutable = function() {
    var _e = [
        new global.Error(),
        -3,
        -27
    ];
    var makeUIMutable = function makeUIMutable(initial, syncDataHolder) {
        var listeners = new Map();
        var value = initial;
        var self = {
            set value (newValue){
                (0, _valueSetter.valueSetter)(self, newValue);
            },
            get value () {
                return value;
            },
            set _value (newValue){
                value = newValue;
                if (syncDataHolder) {
                    _updateDataSynchronously(syncDataHolder, (0, _shareables.makeShareableCloneOnUIRecursive)(newValue));
                }
                listeners.forEach(function(listener) {
                    listener(newValue);
                });
            },
            get _value () {
                return value;
            },
            addListener: function addListener(id, listener) {
                listeners.set(id, listener);
            },
            removeListener: function removeListener(id) {
                listeners.delete(id);
            },
            _animation: null,
            _isReanimatedSharedValue: true
        };
        return self;
    };
    makeUIMutable.__closure = {
        valueSetter: _valueSetter.valueSetter,
        makeShareableCloneOnUIRecursive: _shareables.makeShareableCloneOnUIRecursive
    };
    makeUIMutable.__initData = _worklet_6202761388909_init_data;
    makeUIMutable.__workletHash = 6202761388909;
    makeUIMutable.__stackDetails = _e;
    return makeUIMutable;
}();
var _worklet_12435948459793_init_data = {
    code: "function anonymous(){const{makeUIMutable,initial,syncDataHolder}=this.__closure;return makeUIMutable(initial,syncDataHolder);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/mutables.ts",
    sourceMap: '{"version":3,"names":["anonymous","makeUIMutable","initial","syncDataHolder","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/mutables.ts"],"mappings":"AAyEY,SAAAA,SAAMA,CAAA,QAAAC,aAAA,CAAAC,OAAA,CAAAC,cAAA,OAAAC,SAAA,CAEZ,MAAO,CAAAH,aAAa,CAACC,OAAO,CAAEC,cAAc,CAAC,CAC/C"}',
    version: "3.5.4"
};
var _worklet_12096167784162_init_data = {
    code: "function anonymous(){const{mutable,newValue}=this.__closure;mutable.value=newValue;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/mutables.ts",
    sourceMap: '{"version":3,"names":["anonymous","mutable","newValue","__closure","value"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/mutables.ts"],"mappings":"AAmFgB,SAAAA,SAAMA,CAAA,QAAAC,OAAA,CAAAC,QAAA,OAAAC,SAAA,CACZF,OAAO,CAACG,KAAK,CAAGF,QAAQ,CAC1B"}',
    version: "3.5.4"
};
var _worklet_15082063549120_init_data = {
    code: "function anonymous(){const{mutable,modifier}=this.__closure;mutable.value=modifier(mutable.value);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/mutables.ts",
    sourceMap: '{"version":3,"names":["anonymous","mutable","modifier","__closure","value"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/mutables.ts"],"mappings":"AAoHc,SAAAA,SAAMA,CAAA,QAAAC,OAAA,CAAAC,QAAA,OAAAC,SAAA,CACZF,OAAO,CAACG,KAAK,CAAGF,QAAQ,CAACD,OAAO,CAACG,KAAK,CAAC,CACzC"}',
    version: "3.5.4"
};
function makeMutable(initial) {
    var oneWayReadsOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var value = initial;
    var syncDataHolder;
    if (!oneWayReadsOnly && _NativeReanimated.default.native) {
        syncDataHolder = _NativeReanimated.default.makeSynchronizedDataHolder((0, _shareables.makeShareableCloneRecursive)(value));
        (0, _shareables.registerShareableMapping)(syncDataHolder);
    }
    var handle = (0, _shareables.makeShareableCloneRecursive)({
        __init: function() {
            var _e = [
                new global.Error(),
                -4,
                -27
            ];
            var anonymous = function anonymous() {
                return makeUIMutable(initial, syncDataHolder);
            };
            anonymous.__closure = {
                makeUIMutable: makeUIMutable,
                initial: initial,
                syncDataHolder: syncDataHolder
            };
            anonymous.__initData = _worklet_12435948459793_init_data;
            anonymous.__workletHash = 12435948459793;
            anonymous.__stackDetails = _e;
            return anonymous;
        }()
    });
    var listeners = _NativeReanimated.default.native ? undefined : new Map();
    var mutable = {
        set value (newValue){
            if (_NativeReanimated.default.native) {
                (0, _threads.runOnUI)(function() {
                    var _e = [
                        new global.Error(),
                        -3,
                        -27
                    ];
                    var anonymous = function anonymous() {
                        mutable.value = newValue;
                    };
                    anonymous.__closure = {
                        mutable: mutable,
                        newValue: newValue
                    };
                    anonymous.__initData = _worklet_12096167784162_init_data;
                    anonymous.__workletHash = 12096167784162;
                    anonymous.__stackDetails = _e;
                    return anonymous;
                }())();
            } else {
                (0, _valueSetter.valueSetter)(mutable, newValue);
            }
        },
        get value () {
            if (syncDataHolder) {
                return _NativeReanimated.default.getDataSynchronously(syncDataHolder);
            }
            return value;
        },
        set _value (newValue){
            if (_NativeReanimated.default.native) {
                throw new Error("[Reanimated] Setting `_value` directly is only possible on the UI runtime.");
            }
            value = newValue;
            listeners.forEach(function(listener) {
                listener(newValue);
            });
        },
        get _value () {
            if (_NativeReanimated.default.native) {
                throw new Error("[Reanimated] Reading from `_value` directly is only possible on the UI runtime.");
            }
            return value;
        },
        modify: function modify(modifier) {
            (0, _threads.runOnUI)(function() {
                var _e = [
                    new global.Error(),
                    -3,
                    -27
                ];
                var anonymous = function anonymous() {
                    mutable.value = modifier(mutable.value);
                };
                anonymous.__closure = {
                    mutable: mutable,
                    modifier: modifier
                };
                anonymous.__initData = _worklet_15082063549120_init_data;
                anonymous.__workletHash = 15082063549120;
                anonymous.__stackDetails = _e;
                return anonymous;
            }())();
        },
        addListener: function addListener(id, listener) {
            if (_NativeReanimated.default.native) {
                throw new Error("[Reanimated] Adding listeners is only possible on the UI runtime.");
            }
            listeners.set(id, listener);
        },
        removeListener: function removeListener(id) {
            if (_NativeReanimated.default.native) {
                throw new Error("[Reanimated] Removing listeners is only possible on the UI runtime.");
            }
            listeners.delete(id);
        },
        _isReanimatedSharedValue: true
    };
    (0, _shareables.registerShareableMapping)(mutable, handle);
    return mutable;
}
var _worklet_11709675973052_init_data = {
    code: "function anonymous(){const{initial}=this.__closure;return initial;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/mutables.ts",
    sourceMap: '{"version":3,"names":["anonymous","initial","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/mutables.ts"],"mappings":"AAgJY,SAAAA,SAAMA,CAAA,QAAAC,OAAA,OAAAC,SAAA,CAEZ,MAAO,CAAAD,OAAO,CAChB"}',
    version: "3.5.4"
};
function makeRemote() {
    var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var handle = (0, _shareables.makeShareableCloneRecursive)({
        __init: function() {
            var _e = [
                new global.Error(),
                -2,
                -27
            ];
            var anonymous = function anonymous() {
                return initial;
            };
            anonymous.__closure = {
                initial: initial
            };
            anonymous.__initData = _worklet_11709675973052_init_data;
            anonymous.__workletHash = 11709675973052;
            anonymous.__stackDetails = _e;
            return anonymous;
        }()
    });
    (0, _shareables.registerShareableMapping)(initial, handle);
    return initial;
}
